module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","receipt":"Beleg","filledStock":"Vollgut","empties":"Leergut","transactions":"Buchungen"},"en":{"back":"Back","receipt":"Receipt","filledStock":"Filled Stock","empties":"Empties","transactions":"Transactions"}}')
  delete Component.options._Ctor
}
